<template>
	<page>
		<module title="会员货款补扣款详情">
			<c-detail >
				<c-detail-item label="补扣单号" >
					{{detailData.sup_deduct_number}}
				</c-detail-item>
				<c-detail-item label="状态" >
					{{stateName}}
				</c-detail-item>
				<c-detail-item label="金额" >
					{{detailData.money}}
				</c-detail-item>
				<c-detail-item label="补扣类型" >
					{{detailData.type}}
				</c-detail-item>
				<c-detail-item label="会员昵称" >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="detailData.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{detailData.nick_name||'--'}}</span>
                        </div>
                    </template>
				</c-detail-item>
				<c-detail-item label="会员手机号" >
					{{detailData.user_manage_mobilephone}}
				</c-detail-item>
				<c-detail-item label="会员等级" >
					{{detailData.user_level_name}}
				</c-detail-item>
				<c-detail-item label="会员账号" >
					{{detailData.login_name}}
				</c-detail-item>
				<c-detail-item label="凭证" full>
					<c-image :src="detailData.voucher_img_url" size="120" preview></c-image>
				</c-detail-item>
				<c-detail-item label="备注" full>
					{{detailData.remark}}
				</c-detail-item>
				<c-detail-item  v-if="detailData.state == 1 || detailData.state == 2 || detailData.state == 3 || detailData.state == 4" label="申请时间">
					{{detailData.create_date}}
				</c-detail-item>
				<c-detail-item  v-if="detailData.state == 1 || detailData.state == 2 || detailData.state == 3 || detailData.state == 4" label="申请人姓名">
					{{detailData.create_user_realname}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 2 || detailData.state == 3 || detailData.state == 4" label="审批时间">
					{{detailData.approval_date}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 2 || detailData.state == 3 || detailData.state == 4" label="审批人姓名">
					{{detailData.approval_user_realname}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 3" label="签批时间">
					{{detailData.sign_approval_date}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 3" label="签批人姓名">
					{{detailData.sign_approval_user_realname}}
				</c-detail-item>
				
			</c-detail>
			
			<template slot="button">
				<c-button size="m" v-if="detailData.state == 1" power="b_member_account_supdeduct_approval" @click="approval(detailData,2)">审批</c-button>
				<c-button size="m" v-if="detailData.state == 1" power="b_member_account_supdeduct_approval" hollow @click="approval(detailData,4)">驳回</c-button>
				<c-button size="m" v-if="detailData.state == 2" power="b_member_account_supdeduct_sign" @click="sign(detailData)">签批</c-button>
			</template>
		</module>
		
		<c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="orderApprovalHandle">
			<div class="approval-eason">
				<textarea v-model="approvalReason" placeholder="请输入驳回理由..."></textarea>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'member_account_supdeduct_detail',
		props: {
			id: String
		},
		data() {
			return {
				detailData: {},
				approvalReason: ''
			}
		},
        watch: {
            id(){
                this.detail();
            }
        },
		mounted() {
			this.detail();
		},
		computed: {
			stateName() {
				return {
					0: '草稿',
					1: '待审批',
					2: '待签批',
					3: '已完成',
					4: '驳回'
				}[this.detailData.state];
			},
		},
		methods: {
			detail() {
				this.request({
					url: '/user/account/sup_deduct/detail',
					data: {id: this.id},
					loading: true,
					success: data => {
						this.detailData = data;
					}
				});
			},
			orderApprovalHandle(stop){
				
				if (!this.approvalReason.trim()) {
					this.$message({
						text: '请填写驳回原因'
					});
					stop();
					return;
				}
				this.request({
					url: '/user/account/sup_deduct/approval',
					data: {id:this.id,state:4,reject_reason:this.approvalReason.trim()},
					loading: true,
					success: data => {
						this.$message({
							text: '驳回成功',
							icon: 'success'
						});
						this.$bus.$emit('member_account_supdeduct.update', {})
						this.detail();
					}
				});
			},
			approval(val,state) {
				if(state == 4){
						this.$refs.approvalReason.open();
				}else if(state == 2){
					this.$confirm({
						text: '确定要审批通过【'+val.sup_deduct_number+'】吗？',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/user/account/sup_deduct/approval',
								data: {id:val.id,state:state},
								loading: true,
								success: data => {
									this.$message({
										text: '审批通过成功',
										icon: 'success'
									});
									this.$bus.$emit('member_account_supdeduct.update', {})
									this.detail();
								}
							});
						},  // 确定按钮回调
						cancel: () => {},  // 取消按钮回调
					});
				}
			},
			sign(val) {
				this.$confirm({
					text: '确定要签批【'+val.sup_deduct_number+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/user/account/sup_deduct/sign',
							data: {id:val.id,state:3},
							loading: true,
							success: data => {
								this.$message({
									text: '签批成功',
									icon: 'success'
								});
								this.$bus.$emit('member_account_supdeduct.update', {})
								this.detail();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>
	
<style lang="stylus" scoped>
	.approval-eason {
		padding: 20px;
		
		textarea {
			box-sizing: border-box;
			width: 100%;
			height: 120px;
			border: none;
			padding: 10px 14px;
			line-height: 20px;
			background: #FAFAFA;
			resize: none;
		}
	}
</style>